import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-violet-50 to-purple-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            About Cycle Clarity
          </h1>
          <p className="text-xl text-gray-600">
            Understanding your body should feel simple — not confusing, overwhelming, or clinical.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            <div className="mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                We believe understanding your body should feel simple — not confusing, overwhelming, or clinical.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Cycle Clarity was created to help women make sense of their menstrual cycle using clear language, gentle observation, and practical tools. No medical jargon. No complicated apps. No pressure to "fix" yourself.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                For many women, cycle tracking feels frustrating. Symptoms seem random. Advice is often contradictory. And most tools assume a one-size-fits-all body. We believe the problem isn't your body — it's how information is delivered.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Our approach focuses on pattern awareness, not diagnosis. By noticing rhythms in energy, mood, and physical signals, women can build confidence and clarity around their cycle — without overwhelm.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed">
                The Cycle Clarity Starter Kit is designed to meet you where you are. Whether your cycle feels irregular, confusing, or simply hard to understand, this system offers a calm starting point.
              </p>
            </div>

            {/* Image Section */}
            <div className="my-16 rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/f95cc1563b39cbc0865ebf73746bbef1.jpg"
                alt="Woman practicing mindful cycle tracking"
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Values Section */}
            <div className="grid md:grid-cols-3 gap-8 mt-16">
              <div className="text-center p-6 bg-violet-50 rounded-xl">
                <div className="w-16 h-16 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Simple</h3>
                <p className="text-gray-600">
                  Clear language and practical tools that make sense
                </p>
              </div>

              <div className="text-center p-6 bg-violet-50 rounded-xl">
                <div className="w-16 h-16 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-smile-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Gentle</h3>
                <p className="text-gray-600">
                  No pressure, no judgment — just gentle observation
                </p>
              </div>

              <div className="text-center p-6 bg-violet-50 rounded-xl">
                <div className="w-16 h-16 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Empowering</h3>
                <p className="text-gray-600">
                  Build confidence and clarity around your cycle
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-violet-600 to-purple-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Start Your Journey?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Get the Cycle Clarity Starter Kit and begin understanding your body today
          </p>
          <a
            href="https://payhip.com/b/EvcbM"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-violet-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Your Kit Now
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
